<template>
    <v-list-item color="issue" link :to="'/event/'+item.Event_ID">
        <v-list-item-action>
            <v-icon color="callout">mdi-chevron-right</v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title  >
                {{item.BranchAddress}}
            </v-list-item-title>
            <v-list-item-subtitle>
                {{item.getEventStatus()}}
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <v-list-item-action-text>{{item.getLastDate() | date}} </v-list-item-action-text>
            {{item.getLastDate() | time}}
        </v-list-item-action>
    </v-list-item>
</template>

<script>
    import EventDetails from "../../../wl-core/api/classes/EventDetails";

    export default {
        name: "EventItem",
        props: {
            item: EventDetails
        }
    }
</script>

<style scoped>

</style>
